import React from 'react';

export const redirectText = {
  SSO_CITI_VALIDATE_500: 'Sign in to the Credit Card Portal',
  SSO_SM_500: 'Sign in to the Credit Card Portal',
  SSO_CITI_400: 'Go to the Credit Card Portal',
  SSO_CITI_404: 'Go to the Credit Card Portal',
  SSO_CITI_SNAPSHOT_401: 'Go to the Credit Card Portal',
  SSO_CITI_500: 'Go to the Credit Card Portal',
};

export const defaultCitiUrl = 'https://citiretailservices.citibankonline.com/RSnextgen/svc/launch'
  + '/index.action?siteId=PLCN_HOMEDEPOT#signon&cmp=A~C~C~M~Z~Z~ZZZZ~ZZ~HD~ZZ&desc=R~A~I~Z~Z~Z~ZZZZ~ZZ~HD';

export const payAndManageUrl = {
  PLCN_HOMEDEPOT:
    'https://citiretailservices.citibankonline.com/RSnextgen/svc/launch/index.action?'
    + 'siteId=PLCN_HOMEDEPOT#signon&cmp=A~C~C~M~Z~Z~ZZZZ~ZZ~HD~ZZ&desc=R~A~I~Z~Z~Z~ZZZZ~ZZ~HD',
  PLNP_HOMEDEPOT:
    'https://www.retailservicescommercial.citi.com/USCRSF/CMLSVC/index.html?siteId=PLNP_HOMEDEPOT#sec/signon',
  PLCR_HOMEDEPOT:
    'https://www.retailservicescommercial.citi.com/USCRSF/CMLSVC/index.html?siteId=PLCR_HOMEDEPOT#sec/signon',
};

export const delinkErrorMessage = 'We’re having trouble unlinking your accounts. Please try again '
  + 'later or contact Citibank customer support at 1‑800‑677‑0232 for immediate assistance.';

export const accountUnlinkMessage = {
  PLCN_HOMEDEPOT: 'Consumer Account unlinked!',
  PLNP_HOMEDEPOT: 'Commercial Account unlinked!',
  PLCR_HOMEDEPOT: 'Pro Xtra Account unlinked!',
};

export const delinkSuccessMessage = (siteId) => {
  return [
    <b>{accountUnlinkMessage[siteId]} </b>,
    'You have successfully unlinked your accounts.',
  ];
};
